import { defineMessages } from 'react-intl';

const appHeaderMessages = defineMessages({
  allPackageTypes: {
    description: 'Text for all package types option in rate browser',
    defaultMessage: 'All Package Types',
    id: 'olBiWX',
  },
  home: {
    description: 'link to home page from header',
    defaultMessage: 'Home',
    id: '11/npQ',
  },
  onboard: {
    description: 'headerLinks.onboard',
    defaultMessage: 'Onboard',
    id: 'pY9icx',
  },
  dashboard: {
    description: 'headerLinks.insights',
    defaultMessage: 'Insights',
    id: 'smIyr9',
  },
  analytics: {
    description: 'headerLinks.analytics - sellers on new plans will see Analytics instead of Insights',
    defaultMessage: 'Analytics',
    id: 'CUhjFf',
  },
  orders: {
    description: 'headerLinks.orders',
    defaultMessage: 'Orders',
    id: 'l+Chsy',
  },
  shipments: {
    description: 'headerLinks.shipments',
    defaultMessage: 'Shipments',
    id: 'emlEuR',
  },
  returns: {
    description: 'app header link to returns page',
    defaultMessage: 'Returns',
    id: 'jXn2z8',
  },
  products: {
    description: 'headerLinks.products',
    defaultMessage: 'Products',
    id: 'Pt0Bny',
  },
  customers: {
    description: 'headerLinks.customers',
    defaultMessage: 'Customers',
    id: 'rGorBC',
  },
  scan: {
    description: 'headerLinks.scan',
    defaultMessage: 'Scan',
    id: 'PpCsho',
  },
  settings: {
    description: 'App header title for settings page',
    defaultMessage: 'Settings',
    id: '1402sp',
  },
  rates: {
    description: 'App nav header text for the rate browser',
    defaultMessage: 'Rates',
    id: '5V1tLS',
  },
  addOns: {
    description: 'App nav header text for the add-ons page',
    defaultMessage: 'Add-Ons',
    id: 'kDP/g7',
  },
  automations: {
    description: 'App nav header text for the automations page',
    defaultMessage: 'Automations',
    id: '/pD1UA',
  },
  fulfillments: {
    description: 'App nav header text for the fulfillments page',
    defaultMessage: 'Fulfillments',
    id: 'sBfQqW',
  },
  supplies: {
    description: 'App nav header text for the supplies page',
    defaultMessage: 'Supplies',
    id: 'V5vxG+',
  },
  freight: {
    description: 'App nav header text for the LTL freight page',
    defaultMessage: 'Freight',
    id: 'qWn/PQ',
  },
  settingsLinkTitle: {
    description: 'Tooltip for link to the settings page',
    defaultMessage: 'Settings Page',
    id: 'l+h0R5',
  },
  helpMenuTitle: {
    description: 'Tooltip for the help menu',
    defaultMessage: 'Help Menu',
    id: 'l3mqTq',
  },
  accountMenuTitle: {
    description: 'Tooltip for the account menu',
    defaultMessage: 'Account Menu',
    id: 'F81dl3',
  },
  storeStatusTitle: {
    description: 'Tooltip for the store status dropdown',
    defaultMessage: 'Store Status',
    id: 'ItAz5B',
  },
  notificationHubTitle: {
    description: 'Tooltip for the notification hub',
    defaultMessage: 'Notifications',
    id: 'Y4MIUs',
  },
  labelQueueTitle: {
    description: 'Tooltip for the label queue',
    defaultMessage: 'Label Queue',
    id: 'X5jVoO',
  },
});

const messages = defineMessages({
  betaHeader: {
    description: 'betaHeader.optOutofBeta',
    defaultMessage: 'View Old Layout',
    id: 'lNvFUz',
  },
  dropinInputPlaceholder: {
    description: 'adminMenuDropdown.inputPlaceholder',
    defaultMessage: 'Search Term / Seller ID',
    id: 'j4vX71',
  },
  storeLastUpdated: {
    description: 'appHeader.storeLastUpdated',
    defaultMessage: 'Last updated',
    id: 'I2upSg',
  },
  storeStatusUnknown: {
    description: 'appHeader.storeStatusUnknown',
    defaultMessage: 'Unknown Last Update Date',
    id: 'aYYzna',
  },
  storeStatusQueued: {
    description: 'appHeader.storeStatusQueued',
    defaultMessage: 'Queued for Import',
    id: 'm2OyW4',
  },
  storeStatusImporting: {
    description: 'appHeader.storeStatusImporting',
    defaultMessage: 'Importing orders will continue in background',
    id: 'eFvB9x',
  },
  storeOrdersImportFailure: {
    description: 'appHeader.storeOrdersImportFailure',
    defaultMessage: 'Failed to import',
    id: 'cxURrt',
  },
  storeOrdersImportFailureViewDetails: {
    description: 'appHeader.storeOrdersImportFailureViewDetails',
    defaultMessage: 'View Details',
    id: 'brGKSQ',
  },
  storeCount: {
    description: 'appHeader.storeCount',
    defaultMessage: '{activeStores, plural, one {# Active Store} other {# Active Stores}}',
    id: 'bkANVN',
  },
  updateAllStores: {
    description: 'appHeader.updateAllStores',
    defaultMessage: 'Update All',
    id: '6m0p9I',
  },
  adminInfo: {
    description: 'adminMenuDropdown.informational',
    defaultMessage: "Search by a term, or enter a Seller ID and hit shift-enter to quickly Drop In the seller's account.",
    id: 'o0GG3E',
  },
  stopDropIn: {
    description: 'adminMenuDropdown.stopDropIn',
    defaultMessage: 'Stop Drop In',
    id: 'gXbm/J',
  },
  dropIn: {
    description: 'adminMenuDropdown.dropIn',
    defaultMessage: 'Drop In',
    id: 'eSnc5w',
  },
  dropinMode: {
    description: 'adminMenuDropdown.dropinMode',
    defaultMessage: 'See Features:',
    id: 'ZCE+Yc',
  },
  userSees: {
    description: 'adminMenuDropdown.userSees',
    defaultMessage: 'See what user sees',
    id: '7kamUj',
  },
  seeAllFeatures: {
    description: 'adminMenuDropdown.seeAllFeatures',
    defaultMessage: 'See all features',
    id: '3QN80u',
  },
  ninetyNinePlus: {
    description: 'used to indicate that there are more than ninety-nine units',
    defaultMessage: '99+',
    id: 'iPK9of',
  },
  ldContextMode: {
    description: 'adminMenuDropdown.ldContextMode label for the LD context toggle',
    defaultMessage: 'LD flag context:',
    id: 'F1tVMs',
  },
  sellerFlags: {
    description: 'adminMenuDropdown.sellerFlags option to evaluate LD flags as the impersonated seller',
    defaultMessage: 'Seller Flags',
    id: '5dnXtK',
  },
  adminFlags: {
    description: 'adminMenuDropdown.adminFlags option to evaluate LD flags as the admin seller (100002)',
    defaultMessage: 'Admin Flags',
    id: '7aq+1x',
  },
  dropinExplanation: {
    description: 'adminMenuDropdown.dropinExplanation explains what the drop-in button does',
    defaultMessage: 'Drop in to view the app as a specific seller. Enter a Seller ID to load their account context.',
    id: 'vLDXAX',
  },
});

export default messages;
export { appHeaderMessages };
